import React from 'react';
import Meetings from './../../Meetings';
import MeetingsV2 from './../../Meetingv2';
const MeetingsTab = ({ SelectedBrief, Professionals, SelectedProfessional, AllUsers }) => {
    if (Object.keys(SelectedBrief).includes("brief")) {
        return (
            <div className='BriefInfoSection'>
                <Meetings 
                    Brief={SelectedBrief} 
                    Professionals={Professionals} 
                SelectedProf={SelectedProfessional} 
                AllUsers={AllUsers} 
            />
        </div>
    );
    }else{
        return (
            <div className='BriefInfoSection'>
                <MeetingsV2 
                    Brief={SelectedBrief} 
                    Professionals={Professionals} 
                SelectedProf={SelectedProfessional} 
                AllUsers={AllUsers} 
            />
        </div>
    );
    };
};

export default MeetingsTab;